/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import _ from 'lodash';
import {
  ArrowLeftOutlined,
  CloseOutlined,
  ColumnHeightOutlined,
  ColumnWidthOutlined,
  EnvironmentOutlined,
} from '@ant-design/icons';
import * as L from 'leaflet';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { GetIcon } from 'datastake-daf/dist/components';
import React, { useEffect, useState, createRef, useMemo } from 'react';
import { Button, Table, Checkbox, Space, Radio, Tabs, Select, Input, } from 'antd';
import {
  defaultMapConfig,
  SET_VIEW_DEFAULT_ZOOM,
  useMapHelper,
  getRiskSubTypesTableColumns,
  getDatachainTableColumns,
  getIncidentsTableColumns,
  defaultFilters,
  useMapConfig,
} from './helper';
import Gallery from './gallery';
import { Subject } from './style';
import RiskSelector from './riskSelector';
import { propHasValue } from '../DynamicFormNew/helper';
import { convertDMS, findCoordinatesByCountry } from '../../helpers/map';
import { filterSelectOptions, filterString } from 'datastake-daf/src/helpers/Forms';
import { camelCaseToTitle as camelCaseToSentenceCase } from '../../helpers/StringHelper';
import { getType, dateFormat, getDateRanges, filterValidGPS, mapFiltersConfig } from './config';
import { getPopupContainer } from '../../helpers/popUp';
import { useModule } from '../../helpers/user';
import { getLocales } from '../Table/newTable';

export const useMap = ({
  t = (t) => t,
  data: allData = null,
  user = null,
  language,
  selectedProject,
  sourceId,
  onFiltersChange = () => { },
  module = 'pme',
  initialType = '',
  frameActions,
  activeMapType = '',
  setActiveMapType = () => { },
  siderClassName = '',
  polygon,
}) => {
  const { mod } = useModule();
  const container = createRef();
  const { i18n } = useTranslation();
  const [data, setData] = useState(allData);
  const [mapRef, setMapRef] = useState(null);
  const { TILE_LAYER_URL, MAP_TOKEN } = useMapConfig();
  const [initialMarkerSetIsDone, setInitialMarkerSetIsDone] = useState(false)
  const [mapCenter, setMapCenter] = useState([0, 0]);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);
  const [emptyStateIsVisible, setEmptyStateIsVisible] = useState(false);
  const [initialRecenterDone, setInitialRecenterDone] = useState(false);
  const [initLoaded, setInitLoaded] = useState(false);
  const [polygonLayer, setPolygonLayer] = useState();

  const {
    addIconToMapInitialy,
    activeMarker,
    mapOptionsButtonsConfig,
    setActiveMarker,
    mapMarkers,
    clearMapMarkers,
    getRiskConfig,
    getZoom,
  } = useMapHelper({ mapRef, allData, mapCenter });

  const incidentsTableColumns = useMemo(() => getIncidentsTableColumns(t, mod), [t, mod]);
  const datachainTableColumns = useMemo(() => getDatachainTableColumns(t, mod), [t, mod]);
  const riskSubTypesTableColumns = useMemo(() =>
    getRiskSubTypesTableColumns(t, mod, getRiskConfig), [t, getRiskConfig, mod]);

  const addAllDataToMap = () => {
    clearMapMarkers();
    if (data) {
      if (activeMapType === 'event' || activeMapType === 'datachain') {
        if (propHasValue(data[0])) {
          if (propHasValue(data[0].total)) {
            const totals = data.map((d) => d.total);
            const maxTotal = Math.max(...totals);
            data.forEach((d) => {
              addIconToMapInitialy(
                [d.marker.lat, d.marker.lng],
                activeMapType,
                activeMapType === 'event' ? 'incident' : activeMapType,
                d,
                maxTotal,
              );
            });
          }
        }
      } else if (activeMapType === 'risk') {
        if (data[0] && data[0].data && propHasValue(data[0].data.score)) {
          const totals = data.map((d) => d.data.score.toFixed(1));
          const maxTotal = Math.max(...totals);
          data.forEach((d) => {
            addIconToMapInitialy(
              [d.marker.lat, d.marker.lng],
              activeMapType,
              'risk',
              d,
              maxTotal,
            );
          });
        }
      } else {
        data.forEach((d) => {
          addIconToMapInitialy(
            [d.marker.lat, d.marker.lng],
            d.data.subject,
            d.data.type,
            d.data,
          );
        });
      }
    }
  };

  const createInstance = () => {
    var c = L.DomUtil.get(document.getElementById(container.current));
    if (c != null) {
      c._leaflet_id = null;
    }
    const map = L.map(container.current, defaultMapConfig);
    return map;
  };

  const mapFilters = useMemo(() => (
    (mapFiltersConfig[activeMapType] || []).map(filter => {
      switch (filter.type) {
        case 'riskSelector':
          return <RiskSelector
            t={t}
            key={`${filter.type}-${filter.dest}`}
            filter={filter}
            onChangeValue={(val) => setFilters({ ...Object.assign(filters, { [filter.dest]: val }) })}
          />;
        case 'input':
          return (
            <div
              key={`${filter.type}-${filter.dest}`}
              style={{ marginBottom: 8 }}
            >
              <label>{t(filter.label)}</label>
              <Input
                placeholder={t(filter.placeholder) || t(filter.label)}
                value={filters[filter.dest] || ''}
                onChange={(e) => {
                  if (filter.dest) {
                    setFilters({ ...Object.assign(filters, { [filter.dest]: e.target.value }) })
                  }
                }}
              />
            </div>
          );
        case 'checkbox':
          return <React.Fragment
            key={`${filter.type}-${filter.dest}`}
          >
            {filter.label ? <label>{t(filter.label)}</label> : null}
            <Checkbox.Group
              value={filters[filter.dest] || (filter.options.filter(o => o.default).map(o => o.value) || [])}
              onChange={ev => setFilters({ ...Object.assign(filters, { [filter.dest]: ev }) })}>
              <Space direction="vertical">
                {filter.options.map(option => (
                  <Checkbox key={option.value} value={option.value}>
                    <div className="checkbox-container">
                      <span>{t(option.label)}</span>
                      {option.marker ? <img src={option.marker} alt="img" /> : null}
                    </div>
                  </Checkbox>
                ))}
              </Space>
            </Checkbox.Group>
          </React.Fragment>
        case 'radio':
          return <React.Fragment
            key={`${filter.type}-${filter.dest}`}
          >
            {filter.label ? <label>{t(filter.label)}</label> : null}
            <Radio.Group
              style={{ marginBottom: '1rem' }}
              defaultValue={filters[filter.dest] || (filter.options.find(o => o.default) || { value: null }).value}
              onChange={ev => setFilters({ ...Object.assign(filters, { [filter.dest]: ev.target.value }) })}>
              <Space direction="vertical">
                {filter.options.map(option => (
                  <Radio key={option.value} value={option.value}>
                    {t(option.label)}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          </React.Fragment>
        case 'select':
          return <React.Fragment
            key={`${filter.type}-${filter.dest}`}
          >
            {filter.label ? <label>{typeof filter.label === 'object' ? filter.label[i18n.language] : t(filter.label)}</label> : null}
            <Select
              {...getPopupContainer()}
              allowClear
              showSearch
              filterOption={filterSelectOptions}
              optionFilterProp="children"
              // placeholder={filter.placeholder || filter.label || null}
              value={filters[filter.dest] || (filter.options.find(o => o.default) || { value: null }).value}
              className="map-focus-filter"
              onChange={ev => {
                if (filter.dest === 'riskTypes') {
                  delete filters.riskSubTypes;
                }
                setFilters({ ...Object.assign(filters, { [filter.dest]: ev }) })
              }}>
              {filter.options.filter(option => {
                if (!option.filter) {
                  return true;
                }
                return Object.keys(option.filter).every(key => filters[key] === option.filter[key]);
              }).map(option => (
                <Select.Option
                  key={option.value}
                  value={option.value}>
                  {typeof option.label === 'object' ? option.label[i18n.language] : option.label}
                </Select.Option>
              ))}
            </Select>
          </React.Fragment>
        default:
          return 'undefined type';
      }
    })
  ), [filters, activeMapType]);

  const subject = useMemo(() => {
    const marker = activeMarker && mapMarkers.find((m) => m.id === activeMarker);

    if (marker && data) {
      let name = 'Location Name';
      let type = 'Mine Site';
      const mData = marker.data.data;
      switch (activeMapType) {
        case 'risk':
          if (mData) {
            type = getType(mData.type);
          }
          name = mData ? camelCaseToSentenceCase(mData.name) : '';
          break;
        case 'location':
          if (marker.data) {
            type = getType(marker?.data.type);
          }
          name = marker.data ? camelCaseToSentenceCase(marker.data.name) : '';
          break;
        case 'datachain':
        case 'event':
          if (mData && mData[0]) {
            type = getType(mData[0].locationType);
          }
          name = mData ? mData[0] ? camelCaseToSentenceCase(mData[0].locationName) : '' : '';
          break;
        default:
      }

      const renderRisk = () => (
        <Tabs
          defaultActiveKey="0"
          style={{ marginTop: 10 }}
          items={Object.entries(marker.data.data.riskTypes).map(([key, val], i) => ({
            label: (
              <div style={{ textAlign: 'center' }}>
                <GetIcon icon={val.icon} />
                <p style={{ fontSize: 10, marginTop: 5 }}>
                  {val.name}
                </p>
              </div>
            ),
            tabKey: i.toString(),
            key: i.toString(),
            children: (
              <div className="bordered">
                <div className="header">
                  <h3>{t('List of risk subtypes')}</h3>
                </div>
                <Table
                  locale={getLocales(t)}
                  dataSource={
                    Object.values(marker.data.data.riskTypes) ?
                      Object.values(marker.data.data.riskTypes)[i].subTypes.map((s) => (
                        { ...s, tab: key, locationId: marker.data.data.id, sourceId: marker.data.data.sourceId }
                      )) :
                      []
                  }
                  columns={riskSubTypesTableColumns}
                  pagination={{ pageSize: 4 }}
                />
              </div>
            )
          }))}
        />
      );

      const renderLocation = () => (
        <>
          <div className="cont longitude-latitude">
            <div className="coordinate">
              <label>{t('Latitude')}</label>
              <div className="value">
                <div>
                  <ColumnHeightOutlined />
                </div>
                <div><span>{convertDMS(marker.coordinates[0], marker.coordinates[1])[0] ? convertDMS(marker.coordinates[0], marker.coordinates[1])[0] : 0}</span></div>
              </div>
            </div>
            <div className="coordinate">
              <label>{t('Longitude')}</label>
              <div className="value">
                <div>
                  <ColumnWidthOutlined />
                </div>
                <div><span>{convertDMS(marker.coordinates[0], marker.coordinates[1])[1] ? convertDMS(marker.coordinates[0], marker.coordinates[1])[1] : 0}</span></div>
              </div>
            </div>
          </div>
          {marker.data.sources ? <div className="sources-cont">
            <p className="sources-header">{t('Sources')}</p>
            <div className="sources">
              {marker.data.sources.map((source, i) => {
                return (
                  <div className="source"
                    key={`${source.id}-${i}`}
                  >
                    <div className="main-c">
                      <p>{source.name}</p>
                    </div>
                    <div className="link-cont">
                      <Link
                        target="_blank"
                        rel="noopener noreferrer"
                        to={marker.data?.type === 'mineSite' ?
                          `/app/${mod}/analysis/scl/${marker.data.id}/${marker.data.sourceId}`
                          : `/app/${mod}/view/location/${marker.data.id}?sourceId=${marker.data.sourceId}`}
                      >
                        <Button
                          style={{ margin: '0' }}
                        >
                          {t('View')}
                        </Button>
                      </Link>
                    </div>
                  </div>
                )
              })}
            </div>
          </div> : null}
          {(!marker.data.sources || (Array.isArray(marker.data.sources) && !marker.data.sources.length)) ?
            <div className="go-to-subject">
              <Link
                target="_blank"
                rel="noopener noreferrer"
                to={marker.data?.type === 'mineSite' ?
                  `/app/${mod}/analysis/scl/${marker.data.id}/${marker.data.sourceId}`
                  : `/app/${mod}/view/location/${marker.data.id}?sourceId=${marker.data.sourceId}`}
              >
                <Button type="primary" className="go-to-btn" icon={<ArrowLeftOutlined />}>
                  {t('Go to subject')}
                </Button>
              </Link>
            </div> : null}
        </>
      );

      const renderEvent = () => {
        const dataSource = (marker.data.data || []).map((d) => ({ ...d, key: d.id }));

        return (
          <div className="bordered">
            <div className="header">
              <h3>{t('List of events')}</h3>
            </div>
            <Table
              locale={getLocales(t)}
              size="small"
              pagination={{ pageSize: 8 }}
              dataSource={dataSource}
              columns={incidentsTableColumns}
            />
          </div>
        );
      };

      const renderDatachain = () => {
        const dataSource = (marker.data.data || []).map((d) => ({ ...d, key: d.id }));

        return (
          <div className="bordered">
            <div className="header">
              <h3>{t('List of local information relays')}</h3>
            </div>
            <Table
              locale={getLocales(t)}
              pagination={{ pageSize: 5 }}
              dataSource={dataSource}
              columns={datachainTableColumns}
            />
          </div>
        );
      };

      return (
        <Subject className={siderClassName}>
          <div className="header">
            <div className="main">
              <label>{t(type)}</label>
            </div>
            <div>
              <CloseOutlined
                className="map-focus-filter"
                onClick={() => setActiveMarker(null)}
              />
            </div>
          </div>
          <div className="location-name">
            <div>
              <EnvironmentOutlined />
            </div>
            <div className="main">
              <span>{name}</span>
            </div>
          </div>
          {(activeMapType === 'risk' && marker.data && marker.data.data && typeof marker.data.data.riskTypes === 'object')
            && renderRisk()}
          <Gallery t={t} images={marker.data.images} />
          {(activeMapType === 'location' && marker && marker.coordinates && marker.data && marker.data.id)
            && renderLocation()}
          {(activeMapType === 'event' && Array.isArray(marker.data.data)) && renderEvent()}
          {(activeMapType === 'datachain' && Array.isArray(marker.data.data)) && renderDatachain()}
        </Subject>
      );
    }
    return null;
  }, [activeMarker, t, activeMapType, data, riskSubTypesTableColumns, datachainTableColumns, incidentsTableColumns, mapMarkers, mod, setActiveMarker]);

  useEffect(() => {
    if (initialMarkerSetIsDone) {
      setInitialMarkerSetIsDone(undefined);
    }
  }, [selectedProject, sourceId]);

  useEffect(() => {
    if (!mapRef) {
      const instance = createInstance();
      setMapRef(instance);
    }
  }, []);

  useEffect(() => {
    if (mapRef) {
      if (polygonLayer) {
        mapRef.removeLayer(polygonLayer)
      }

      if (Array.isArray(polygon)) {
        const layer = L.polygon(polygon, { color: '#00809E' })
          .addTo(mapRef);
        setPolygonLayer(layer);
      }
    }
  }, [polygon, mapRef]);

  useEffect(() => {
    if (frameActions) {
      if (allData) {
        if (allData.length === 0) {
          setEmptyStateIsVisible(true);
        } else if (emptyStateIsVisible) {
          setEmptyStateIsVisible(false);
        }
        frameActions.loading(false);
        setData(filterValidGPS(allData));
      } else {
        if (data) {
          setData(null);
        }
        frameActions.loading(true);
      }
    } else {
      setInitialMarkerSetIsDone(false);
    }
  }, [frameActions, allData]);

  useEffect(() => {
    if (allData) {
      if (activeMapType === 'location') {
        const arr = (filters.type && Array.isArray(filters.type)) ? filters.type : ['mineSite', 'village', 'other']
        setData(filterValidGPS(allData.filter((d) =>
          d.data.type &&
          d.data.name &&
          arr.includes(d.data.type) &&
          (!filters.locationName || filterString(d.data.name, filters.locationName)),
        )));
      } else if (activeMapType === 'datachain') {
        clearMapMarkers();
        setData(filterValidGPS(_.cloneDeep(allData || []).map(marker => {
          if (Array.isArray(marker.data)) {
            marker.data = marker.data.filter(item => {
              return Object.keys(filters).filter(key => !['legend', 'period'].includes(key)).map(key => Array.isArray(filters[key])
                ? filters[key].includes(item[key])
                : filters[key] === item[key]).filter(v => v).length > 0;
            });
            marker.total = marker.data.length;
          } else {
            const item = marker.data;
            marker.data = Object.keys(filters).filter(key => !['legend', 'period'].includes(key)).map(key => Array.isArray(filters[key])
              ? filters[key].includes(item[key])
              : filters[key] === item[key]).filter(v => v).length > 0;
            marker.total = 1;
          }
          return marker;
        }).filter(marker => marker.data.length)));
        addAllDataToMap();
      } else if (activeMapType === 'risk') {
        clearMapMarkers();
        const [min, max] = filters.riskScore || [1, 5];
        setData(filterValidGPS(_.cloneDeep(allData || []).map(marker => {
          if (filters.riskTypes) {
            marker.data.riskTypes = Object.keys(marker.data.riskTypes).reduce((item, category) => {
              if (
                filters.riskTypes === category &&
                marker.data.riskTypes[category].subTypes.length
              ) {
                item[category] = marker.data.riskTypes[category];
                if (filters.riskSubTypes) {
                  item[category].subTypes = marker.data.riskTypes[category].subTypes.filter(sType => sType.key === filters.riskSubTypes);
                }
              }
              return item;
            }, {});
          }
          return marker;
        }).filter(marker => (!filters.riskTypes || (marker.data.riskTypes[filters.riskTypes] && marker.data.riskTypes[filters.riskTypes].subTypes.length))
          && marker.data.score && marker.data.score.toFixed(1) >= min && marker.data.score.toFixed(1) <= max)));
        addAllDataToMap();
      } else if (activeMapType === 'event') {
        clearMapMarkers();
        setData(filterValidGPS(_.cloneDeep(allData || []).map(marker => {
          if (Array.isArray(marker.data)) {
            marker.data = marker.data.map(d => {
              if (filters.riskSubTypes) {
                d.associatedRisk = (d.associatedRisk || []).filter(f => f === filters.riskSubTypes);
              }
              if (filters.riskTypes) {
                d.riskGroups = d.riskGroups.filter(f => f === filters.riskTypes);
              }
              if (filters.period && filters.period !== 'all') {
                const ranges = getDateRanges(filters.period);
                d.inRange = ranges.includes(dateFormat(filters.period, moment(d.date)));
              } else {
                d.inRange = true
              }
              return d;
            }).filter(d => d.inRange && (!filters.riskSubTypes || d.associatedRisk.length) && (!filters.riskTypes || d.riskGroups.length));
          }
          marker.total = marker.data.length;
          return marker;
        }).filter(marker => marker.total)));
        addAllDataToMap();
      }
    }
  }, [filters, activeMapType]);

  useEffect(() => {
    setFiltersOpen(false);
    setFilters(defaultFilters);
    clearMapMarkers();
    if (activeMapType) {
      if (initialMarkerSetIsDone || module === 'pme') {
        onFiltersChange({
          widget: 'map',
          filters: {
            subject: activeMapType,
          },
        });
        if (!initLoaded) {
          setInitLoaded(true);
        }
      } else {
        setInitialMarkerSetIsDone(false);
      }
    }
  }, [activeMapType, language]);

  useEffect(() => {
    if (!initialMarkerSetIsDone) {
      if (activeMapType === initialType) {
        if (initLoaded) {
          onFiltersChange({
            widget: 'map',
            filters: {
              subject: activeMapType,
            },
          });
        }
      } else {
        setActiveMapType(initialType);
      }
    }
  }, [initialMarkerSetIsDone, initialType]);

  useEffect(() => {
    if (!activeMapType) {
      setActiveMapType(initialType);
    }
  }, [activeMapType]);

  useEffect(() => {
    if (mapRef) {
      L.control.scale().addTo(mapRef);
      L.tileLayer(TILE_LAYER_URL, { access_token: MAP_TOKEN }).addTo(mapRef);
    }
  }, [mapRef]);

  useEffect(() => {
    if (mapRef) {
      if (allData && allData.length && !initialRecenterDone) {
        const pos = allData.map(m => [Number(m.marker.lat), Number(m.marker.lng)]);
        const bounds = new L.LatLngBounds(pos);
        mapRef.fitBounds(bounds);
        setInitialRecenterDone(true);
      }
    }
  }, [allData, mapRef]);

  useEffect(() => {
    if (mapRef) {
      if (user && !(allData || []).length) {
        const coordinates = findCoordinatesByCountry(user.country) || [0, 0];
        mapRef.setView([coordinates[1], coordinates[0]], SET_VIEW_DEFAULT_ZOOM);
        setMapCenter([coordinates[1], coordinates[0]]);
      }
    }
  }, [user, mapRef]);

  useEffect(() => {
    setInitialRecenterDone(false);
  }, [selectedProject, sourceId]);

  useEffect(() => {
    if (mapRef && data) {
      if (!initialMarkerSetIsDone) {
        setInitialMarkerSetIsDone(true);
      } else {
        clearMapMarkers();
      }
      addAllDataToMap();
    }
  }, [data, mapRef, activeMapType]);

  useEffect(() => {
    const marker = mapMarkers.find((m) => m.id === activeMarker);
    if (getZoom && marker && mapRef) {
      mapRef.setView([marker.coordinates[0], marker.coordinates[1]], getZoom(mapRef));
    }
  }, [activeMarker]);

  useEffect(() => {
    if (Object.keys(filters).length > 0) {
      setFilters(defaultFilters);
      setFiltersOpen(false);
    }
  }, [sourceId, selectedProject]);

  return {
    filtersOpen,
    setFiltersOpen,
    mapFilters,
    container,
    activeMarker,
    subject,
    mapOptionsButtonsConfig,
    emptyStateIsVisible,
    setEmptyStateIsVisible,
  }
}
